import { API_ADMIN_URL } from "../../config/constants";
import { deleteRequest, postRequest } from "../API";

/*********************************************************
 * Function Name : List
 * Description   : Get list of all tickers
 * By            : Afsar Ali
 * Date          : 02-04-2024
 *********************************************************/
export const list = async (options) => {
  try {
    const params = {
      url: `${API_ADMIN_URL}cms/tickers/list`,
      postData: options,
    };
    const res = await postRequest(params);
    if (res.status === true || res.status === 200) {
      return {
        status: true,
        result: res?.data?.response?.result,
        count: res?.data?.response?.count,
      };
    } else {
      return { status: false, message: res?.response?.data?.statusMessage };
    }
  } catch (error) {
    console.log(error);
    return {
      status: false,
      message: "Under Maintenance, Please try after some time.",
    };
  }
}; //End of Function

/*********************************************************
 * Function Name : addeditdata
 * Description   : this function is used for Add/Edit ticker
 * By            : Afsar Ali
 * Date          : 02-04-2024
 *********************************************************/
export const addeditdata = async (options) => {
  try {
    const params = {
      url: `${API_ADMIN_URL}cms/tickers/addeditdata`,
      postData: options,
    };
    const res = await postRequest(params);
    if (res.status === true || res.status === 200) {
      return { status: true, result: res?.data?.response?.result };
    } else {
      return { status: false, message: res?.response?.data?.statusMessage };
    }
  } catch (error) {
    return {
      status: false,
      message: "Under Maintenance, Please try after some time.",
    };
  }
}; //End of Function

/*********************************************************
 * Function Name : chnageStatus
 * Description   : This function is used for change ticker status
 * By            : Afsar Ali
 * Date          : 02-04-2024
 *********************************************************/
export const chnageStatus = async (options) => {
  try {
    const params = {
      url: `${API_ADMIN_URL}cms/tickers/change-status`,
      postData: {
        ...options,
        ipAddress: sessionStorage.getItem("IP_ADDRESS"),
      },
    };
    const res = await postRequest(params);
    if (res.status === true || res.status === 200) {
      return { status: true, result: res?.data?.response?.result };
    } else {
      return { status: false, message: res?.response?.data?.statusMessage };
    }
  } catch (error) {
    return {
      status: false,
      message: "Under Maintenance, Please try after some time.",
    };
  }
}; //End of Function

/*********************************************************
 * Function Name : delete data
 * Description   : This function is used to delete ticker.
 * By            : Afsar Ali
 * Date          : 02-04-2024
 *********************************************************/
export const deleteTicker = async (options) => {
  try {
    const params = {
      url: `${API_ADMIN_URL}cms/tickers/delete`,
      postData: options,
    };
    const res = await postRequest(params);
    if (res.status === true || res.status === 200) {
      return { status: true, result: res?.data?.response?.result };
    } else {
      return { status: false, message: res?.response?.data?.statusMessage };
    }
  } catch (error) {
    return {
      status: false,
      message: "Under Maintenance, Please try after some time.",
    };
  }
}; //End of Function
